import { noop } from 'utility-belt/utilityFunctions';
import { ContractAction } from '../types';
import { useCommonValidation, COMMON_VALIDATION_ERRORS } from '../hooks/useCommonValidation';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useMemo } from 'react';
import { events } from '../../../event-tracking';
import { ACTION_LOADING_MESSAGE_KEY } from '../utils/constants';
import { isActionUnavailable } from '../utils/utilities';
import { ContractStatus } from '../../../constants';
import { useContractData } from '../../../hooks/useFetchContractData';
import { hasContractM1Gate } from '../../../utils/gates';
const PRIMARY_LABEL = 'commerceContractLib.actions.UPDATE_PAYMENT_METHOD.label';
export const UPDATE_PAYMENT_METHOD_VALIDATION_ERRORS = {
  notAutomaticCollection: 'notAutomaticCollection'
};
export const UpdatePaymentMethodValidationMessages = Object.freeze({
  [COMMON_VALIDATION_ERRORS.unauthorized]: 'commerceContractLib.actions.UPDATE_PAYMENT_METHOD.errors.unauthorized',
  [COMMON_VALIDATION_ERRORS.jitaUser]: 'commerceContractLib.actions.UPDATE_PAYMENT_METHOD.errors.jitaUser'
  // TODO: Add when RPC validation is implemented
  // contractTerminated: 'commerceContractLib.actions.UPDATE_PAYMENT_METHOD.errors.contractTerminated',
});
export const useUpdatePaymentMethodAction = ({
  objectId,
  objectTypeId,
  skip
}) => {
  const queryData = useContractData({
    objectId,
    objectTypeId
  }, {
    skip
  });
  const commonValidation = useCommonValidation({
    objectId,
    objectTypeId,
    skip
  });
  const sendOpenContractUpdatePaymentMethodModal = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_CONTRACT_UPDATE_PAYMENT_METHOD_MODAL);
  return useMemo(() => {
    var _queryData$data, _data$properties, _data$properties2, _data$properties3;
    const isUnavailable = isActionUnavailable({
      objectId,
      objectTypeId,
      skip
    }) || !hasContractM1Gate() || ((_queryData$data = queryData.data) === null || _queryData$data === void 0 || (_queryData$data = _queryData$data.properties) === null || _queryData$data === void 0 || (_queryData$data = _queryData$data.hs_hubspot_billing_enabled) === null || _queryData$data === void 0 ? void 0 : _queryData$data.value) !== 'true';
    if (isUnavailable) {
      return ContractAction.unavailable();
    }
    const {
      loading,
      data
    } = queryData;
    if (loading) {
      return ContractAction.loading({
        messageKey: PRIMARY_LABEL,
        onClick: noop,
        loadingMessageKey: ACTION_LOADING_MESSAGE_KEY
      });
    }
    if (!data) {
      return ContractAction.unavailable();
    }
    if (commonValidation) {
      return ContractAction.invalid({
        validationMessageKey: UpdatePaymentMethodValidationMessages[commonValidation],
        messageKey: PRIMARY_LABEL,
        onClick: noop
      });
    }

    // TODO: update this to use the RPC validation
    const contractTerminated = (data === null || data === void 0 || (_data$properties = data.properties) === null || _data$properties === void 0 || (_data$properties = _data$properties.hs_status) === null || _data$properties === void 0 ? void 0 : _data$properties.value) === ContractStatus.Terminated;
    if (contractTerminated) {
      return ContractAction.unavailable();
    }

    // TODO: update this to use the RPC validation
    const isBillingEnabled = (data === null || data === void 0 || (_data$properties2 = data.properties) === null || _data$properties2 === void 0 || (_data$properties2 = _data$properties2.hs_hubspot_billing_enabled) === null || _data$properties2 === void 0 ? void 0 : _data$properties2.value) === 'true';
    if (!isBillingEnabled) {
      return ContractAction.unavailable();
    }

    // TODO: update this to use the RPC validation
    const isCPQContract = (data === null || data === void 0 || (_data$properties3 = data.properties) === null || _data$properties3 === void 0 || (_data$properties3 = _data$properties3.hs_object_source) === null || _data$properties3 === void 0 ? void 0 : _data$properties3.value) === 'API';
    if (!isCPQContract) {
      return ContractAction.unavailable();
    }
    return ContractAction.ok({
      messageKey: PRIMARY_LABEL,
      onClick: () => {
        events.UPDATE_PAYMENT_METHOD.open();
        sendOpenContractUpdatePaymentMethodModal({
          contractId: objectId
        });
      }
    });
  }, [skip, queryData, objectTypeId, commonValidation, sendOpenContractUpdatePaymentMethodModal, objectId]);
};